// Country Flags Section - Social Proof Component
import { Badge } from "@/components/ui/badge";
import { Globe } from "lucide-react";

// Countries we serve with their flag emojis and patient counts
const COUNTRIES = [
  { code: "NG", name: "Nigeria", flag: "🇳🇬", patients: "1,200+" },
  { code: "KE", name: "Kenya", flag: "🇰🇪", patients: "800+" },
  { code: "GH", name: "Ghana", flag: "🇬🇭", patients: "650+" },
  { code: "TZ", name: "Tanzania", flag: "🇹🇿", patients: "420+" },
  { code: "UG", name: "Uganda", flag: "🇺🇬", patients: "380+" },
  { code: "ET", name: "Ethiopia", flag: "🇪🇹", patients: "290+" },
  { code: "ZA", name: "South Africa", flag: "🇿🇦", patients: "180+" },
  { code: "AE", name: "UAE", flag: "🇦🇪", patients: "350+" },
  { code: "SA", name: "Saudi Arabia", flag: "🇸🇦", patients: "280+" },
  { code: "OM", name: "Oman", flag: "🇴🇲", patients: "150+" },
  { code: "BD", name: "Bangladesh", flag: "🇧🇩", patients: "520+" },
  { code: "NP", name: "Nepal", flag: "🇳🇵", patients: "180+" },
  { code: "AF", name: "Afghanistan", flag: "🇦🇫", patients: "120+" },
  { code: "US", name: "USA", flag: "🇺🇸", patients: "90+" },
  { code: "GB", name: "UK", flag: "🇬🇧", patients: "75+" },
  { code: "CA", name: "Canada", flag: "🇨🇦", patients: "60+" },
];

export default function CountryFlagsSection() {
  return (
    <section className="py-16 bg-white border-y border-slate-100" data-testid="country-flags-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
            <Globe className="h-3 w-3 mr-1" /> Global Reach
          </Badge>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-3">
            Trusted by Patients from <span className="text-orange-600">50+ Countries</span>
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto">
            We've helped thousands of international patients from across Africa, Middle East, Asia, and beyond receive world-class medical care in India.
          </p>
        </div>

        {/* Flag Grid */}
        <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-4">
          {COUNTRIES.map((country) => (
            <div
              key={country.code}
              className="group flex flex-col items-center p-3 rounded-xl hover:bg-orange-50 transition-colors cursor-default"
              data-testid={`country-${country.code}`}
            >
              <span className="text-4xl mb-2 group-hover:scale-110 transition-transform">{country.flag}</span>
              <p className="text-xs font-medium text-slate-900 text-center">{country.name}</p>
              <p className="text-[10px] text-orange-600 font-semibold">{country.patients}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
